import { TFunction } from "i18next";

import { ChatRatings } from "./types";

export interface RatingLabel {
  key: string;
  label: string;
}

// eslint-disable-next-line id-length -- keep "t" as the standard i18n translation helper for readability and tooling support
export const getTextRatingLabels = (t: TFunction) => ({
  [ChatRatings.TERRIBLE]: `${t("chat:chatBubbleRating.rating.terrible")}! ${t("chat:chatBubbleRating.secondaryText.terrible")}`,
  [ChatRatings.BAD]: `${t("chat:chatBubbleRating.rating.bad")}! ${t("chat:chatBubbleRating.secondaryText.bad")}`,
  [ChatRatings.GREAT]: `${t("chat:chatBubbleRating.rating.great")}! ${t("chat:chatBubbleRating.secondaryText.great")}`,
  [ChatRatings.FANTASTIC]: `${t("chat:chatBubbleRating.rating.fantastic")}! ${t("chat:chatBubbleRating.secondaryText.fantastic")}`,
});

// eslint-disable-next-line id-length -- keep "t" as the standard i18n translation helper for readability and tooling support
export const getAdditionalTextLabels = (t: TFunction) => ({
  [ChatRatings.TERRIBLE]: [
    { key: "Out of Character", label: t("chat:chatBubbleRating.messageLabels.outOfCharacter") },
    { key: "Bad Memory", label: t("chat:chatBubbleRating.messageLabels.badMemory") },
    { key: "Repetitive", label: t("chat:chatBubbleRating.messageLabels.repetitive") },
    { key: "Empty Response", label: t("chat:chatBubbleRating.messageLabels.emptyResponse") },
    { key: "Incomplete", label: t("chat:chatBubbleRating.messageLabels.incomplete") },
    { key: "Respond as User", label: t("chat:chatBubbleRating.messageLabels.respondAsUser") },
  ],
  [ChatRatings.BAD]: [
    { key: "Out of Character", label: t("chat:chatBubbleRating.messageLabels.outOfCharacter") },
    { key: "Bad Memory", label: t("chat:chatBubbleRating.messageLabels.badMemory") },
    { key: "Repetitive", label: t("chat:chatBubbleRating.messageLabels.repetitive") },
    { key: "Empty Response", label: t("chat:chatBubbleRating.messageLabels.emptyResponse") },
    { key: "Incomplete", label: t("chat:chatBubbleRating.messageLabels.incomplete") },
    { key: "Respond as User", label: t("chat:chatBubbleRating.messageLabels.respondAsUser") },
  ],
  [ChatRatings.GREAT]: [
    { key: "Interesting", label: t("chat:chatBubbleRating.messageLabels.interesting") },
    { key: "Funny", label: t("chat:chatBubbleRating.messageLabels.funny") },
    { key: "Good Memory", label: t("chat:chatBubbleRating.messageLabels.goodMemory") },
    { key: "Spicy", label: t("chat:chatBubbleRating.messageLabels.spicy") },
    { key: "Unique", label: t("chat:chatBubbleRating.messageLabels.unique") },
  ],
  [ChatRatings.FANTASTIC]: [
    { key: "Interesting", label: t("chat:chatBubbleRating.messageLabels.interesting") },
    { key: "Funny", label: t("chat:chatBubbleRating.messageLabels.funny") },
    { key: "Good Memory", label: t("chat:chatBubbleRating.messageLabels.goodMemory") },
    { key: "Spicy", label: t("chat:chatBubbleRating.messageLabels.spicy") },
    { key: "Unique", label: t("chat:chatBubbleRating.messageLabels.unique") },
  ],
});

// eslint-disable-next-line id-length -- keep "t" as the standard i18n translation helper for readability and tooling support
export const getAdditionalImageLabels = (t: TFunction) => ({
  [ChatRatings.TERRIBLE]: [
    { key: "Irrelevant", label: t("chat:chatBubbleRating.imageLabels.irrelevant") },
    { key: "Malformed", label: t("chat:chatBubbleRating.imageLabels.malformed") },
    { key: "Offensive", label: t("chat:chatBubbleRating.imageLabels.offensive") },
    { key: "Scary", label: t("chat:chatBubbleRating.imageLabels.scary") },
  ],
  [ChatRatings.BAD]: [
    { key: "Irrelevant", label: t("chat:chatBubbleRating.imageLabels.irrelevant") },
    { key: "Malformed", label: t("chat:chatBubbleRating.imageLabels.malformed") },
    { key: "Offensive", label: t("chat:chatBubbleRating.imageLabels.offensive") },
    { key: "Scary", label: t("chat:chatBubbleRating.imageLabels.scary") },
  ],
  [ChatRatings.GREAT]: [
    { key: "Relevant", label: t("chat:chatBubbleRating.imageLabels.relevant") },
    { key: "Surprising", label: t("chat:chatBubbleRating.imageLabels.surprising") },
    { key: "Interesting", label: t("chat:chatBubbleRating.messageLabels.interesting") },
    { key: "Spicy", label: t("chat:chatBubbleRating.messageLabels.spicy") },
  ],
  [ChatRatings.FANTASTIC]: [
    { key: "Relevant", label: t("chat:chatBubbleRating.imageLabels.relevant") },
    { key: "Surprising", label: t("chat:chatBubbleRating.imageLabels.surprising") },
    { key: "Interesting", label: t("chat:chatBubbleRating.messageLabels.interesting") },
    { key: "Funny", label: t("chat:chatBubbleRating.messageLabels.funny") },
    { key: "Spicy", label: t("chat:chatBubbleRating.messageLabels.spicy") },
  ],
});

export const COPIED_MESSAGE = "Copied to clipboard";
export const ANONYMOUS_DISPLAY_NAME = "You";
export const ANONYMOUS_CONVERSATION_NAME = "Honey";
